import React from "react";
import DashboardSidebarBase from "@/components/ui/DashboardSidebar";
import { LayoutDashboard, Users, BarChart3, DollarSign, Table, BookOpen } from "lucide-react";

export default function DashboardSidebar(props) {
  const menuItems = [
    { id: "summary", title: "Summary", icon: LayoutDashboard },
    { id: "insights", title: "Detailed Insights", icon: Users },
    { id: "poc-level-analysis", title: "POC Level Analysis", icon: Table },
    { id: "benchmarks", title: "Benchmarks", icon: BarChart3 },
    { id: "roi", title: "ROI", icon: DollarSign },
    { id: "glossary", title: "Glossary", icon: BookOpen },
  ];

  return <DashboardSidebarBase {...props} menuItems={menuItems} />;
}